<template>
    <div v-if="form.user !== {}">
        <div class="avatar-upload-wrapper stagger-in-up">
            <avatar-upload :user="user" @updated="$emit('updated')"></avatar-upload>
        </div>
        <form-with-loader class="edit-profile-form" :form="form" v-if="form.user" @success="onSuccess"
                          autocomplete="off">
            <div>
                <label for="name">Your Name</label>
                <error :error="form.validator.getError('user_name')"></error>
                <input id="name" v-model="form.user_name" type="text">
            </div>
            <div>
                <label for="email">Email</label>
                <error :error="form.validator.getError('email')"></error>
                <input id="email" v-model="form.email" type="text">

            </div>
            <div>
                <label for="email">New Password</label>
                <error :error="form.validator.getError('password')"></error>
                <input id="password" v-model="form.password" type="password">
            </div>
            <div>
                <label for="email">Current Password *</label>
                <error :error="form.validator.getError('current_password')"></error>
                <input id="current_password" v-model="form.current_password" type="password">
            </div>
            <template slot="button-text">Save</template>
        </form-with-loader>
        <p class="mt-4" v-if="successMessage">{{ successMessage }}</p>
    </div>
</template>
<script>
    import AvatarUpload   from "./Components/AvatarUpload"
    import Error          from "vuetiful-forms/src/components/Error"
    import ForgotPassword from "./Auth/ForgotPassword"
    import FormWithLoader from "../../../App/Views/Components/FormWithLoader";
    import IconPencil     from "../../../Lib/Icons/IconPencil"
    import Transition     from "../../../Lib/Objects/Transition"

    export default {
        name: 'edit-user',
        components: {
            AvatarUpload,
            Error,
            ForgotPassword,
            FormWithLoader,
            IconPencil,
        },
        props: {
            form: {},
            user: {}
        },
        data() {
            return {
                successMessage: false,
            }
        },
        methods: {
            onSuccess() {
                this.successMessage = 'Profile updated!';
                this.$emit('updated');
            }
        }
    }
</script>


<style lang="scss">

    .error {
        font-size: 11px;
        background-color: #f85045;
        padding: 2px 6px;
        border-radius: 3px 3px 0 0;
        margin-left: 2px;
        width: 300px;
        display: block;
        color: #fff;
    }
    #current_password {
        display: block;
    }
</style>